import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Contacto from './contacto.css';
import EditOrange from '../img/edit_orange_24px.png';
import EditGray from '../img/edit_gray_24px.png';
import { areas } from "../properties";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { validacionEmail, validacionTel } from "../miPerfil/servicios.act";
import { cierraSesionAppLogin } from "../app-database";
import {  guardarAreaOcupacion, guardarMedios} from "../miPerfil/datos.act";
import {
	database as db,
	authentication as auth
} from "../app-database";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { goTo } from "../tools";

const MSJERRORCORREO = "Error en el correo electrónico.";
const ERRORMSJCEL = "Error en el teléfono celular.";
const ERRORCOUNTFIJO = "Error en el teléfono fijo.";
const campoRequerido = "Campo requerido";
const inputActive = inputActive;
const color = '#AAC3EE';
const borderColor = '#FF6B0B';
const telefonoIncorrecto = "Tu teléfono celular es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional.";
const telefonoDiferente = "Tu número de teléfono debe ser diferente.";
const telefonoFijo = "Tu teléfono fijo es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional.";
const palabraError = 'error';
var errorEmail = true;
var	errorTelFijo = true;
var	errorTelCelular = true;
const mapState = (state) => {
	return {
		initialValues: {
			loading: state.global.loading,
			codFiliacion: state.registro.codFiliacion,
			idParticipante: state.registro.idParticipante,
			conectaMovil: state.global.conectaMovil,
			dispositivo: state.global.dispositivo,
			showAviso: state.registro.showAviso,
			usuario: state.miPerfil.usuario,
			lada: state.miPerfil.lada,
			celular: state.miPerfil.celular,
			ladaFijo: state.miPerfil.ladaFijo,
			telefono: state.miPerfil.telefono,
			ocupacion: state.miPerfil.ocupacion,
			areaDeInteres: state.miPerfil.areaDeInteres,
			objTemporal: state.miPerfil.objTemporal,
			editing: state.miPerfil.editingDP
		}
	};
};

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento });
		},
		guardarAreaOcupacion: (datos) => {
			dispatch(guardarAreaOcupacion(datos));
		},
		guardarMedios: (datos) => {
			dispatch(guardarMedios(datos));
		},
	};
};


const floatingLabelFocusStyleSettings = {
	...campoSettings,
	color: '#FF6B0B',
	letterSpacing: '0.5px',
	lineHeight: '16px',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	color: '#567099',
	letterSpacing: '0.5px',
	lineHeight: '16px',
}

const campoSettings = {
	fontStyle: 'normal',
	mixBlendMode: 'normal',
	fontFamily: 'Open Sans',
	fontWeight: 'normal',
}

const campo = ({ input, label, max, type, focusSS, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: color }}
				underlineFocusStyle={{ borderColor: borderColor }}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				floatingLabelStyle={floatingLabelStyleSettings}
				type={type}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				onFocus={focusSS}
				maxLength={max}
				errorText={touched && error}
			/>
		</MuiThemeProvider>
	);
};

const campoSelect = ({ input, label, change, name, meta: { touched, error }, children, ...custom }) => {
	return (
		<MuiThemeProvider>
			<SelectField
				{...input}
				name={name}
				floatingLabelText={label}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onChange={(event, index, value) => {
					input.onChange(value);
					change(event, index, value, name);
				}}
				children={children}
				fullWidth={true}
				errorText={touched && error}
				{...custom}
			/>
		</MuiThemeProvider>
	);
};

class ContactoForm extends React.Component {
	contadorEmailContacto = 0;
	countCelularContactoS = 0;
	contadorFijoC = 0;
	cambioEmail = false;
	cambioCel = false;
	cambioFijoContacto = false;
	correosValidadosContacto = [];
	telefonosValidados = {};
	ladaCel = '';
	ladaFijo = '';
	state = {
		viewBoton: false,
		iconEdit: EditOrange,
		usuario: "",
		lada: "",
		celular: "",
		ladaFijo: "",
		telefono: "",
		ocupacion: "",
		areaDeInteres: this.props.areaDeInteres,
		areaDeInteresId: 0,
		mensajeAviso: "",
		messageExito: false,
		messageError: false,
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		inputType: "",
		inputType2: "",
		sistema: "",
		errorUsuarioMsj: "",
		errorUsuarioCMsj: "",
		errorCelMsj: "",
		errorTelMsj: "",
		checkFlag: false,
		tituloOne: "",
		mensajeOne: "",
		tituloTwo: "",
		mensajeTwo: "",
	}

	componentDidMount = () => {
		this.state.iconEdit = EditOrange;
	 	this.cargarDatos();
	}

	componentWillUnmount() {
		this.state.iconEdit = EditOrange;
	}

	cargarDatos = () => {
		console.log('manda a llamar');
		db.ref("miPerfil/" + auth.currentUser.uid).once(
			"value",
			(snapshot) => {
				const data = snapshot.val();
				console.log('nombre area',data);
				var idArea = parseInt(data.datosPersonales.areaInteres ? data.datosPersonales.areaInteres : "0");
				var nombreArea = areas.filter(item => item.id === idArea);
				this.setState({ usuario: data.datosPersonales.usuario ? data.datosPersonales.usuario : "" });
				this.setState({ celular: data.datosPersonales.numeroCelular ? 
					data.datosPersonales.ladaCelular + data.datosPersonales.numeroCelular : ""});
				this.setState({ telefono: data.datosPersonales.numeroFijo ? 
					data.datosPersonales.ladaFijo + data.datosPersonales.numeroFijo : ""});
				this.setState({ ocupacion: data.datosPersonales.ocupacion ? data.datosPersonales.ocupacion : "" });
				this.setState({ areaDeInteres: nombreArea.length > 0 ? nombreArea[0].area : "" });
				this.setState({areaDeInteresId: idArea});
			},
			(reason) => {
				throw reason;
			});
	}

	cargarDatosEdit = () => {
		this.props.change("usuario", this.state.usuario);
		this.props.change("celular", this.state.celular);
		this.props.change("telefono", this.state.telefono);
		this.props.change("ocupacion", this.state.ocupacion);
		this.props.change({ areaDeInteres: this.state.areaDeInteresId});
		console.log(this.state.areaDeInteresId);

	}

	cancelar = () => {
		this.setState({ iconEdit: EditOrange });
		this.setState({ viewBoton: false });
		this.cargarDatos();
	}

	edit = () => {
		if (this.state.iconEdit === EditOrange) {
			this.setState({ iconEdit: EditGray });
			this.setState({ viewBoton: true })
		} else if (this.state.iconEdit === EditGray) {
			this.setState({ iconEdit: EditOrange });
			this.setState({ viewBoton: false })
		}
		this.cargarDatosEdit();
	}

	validateEmailContacto = (email) => {
		var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return pattern.test(email);
	}

	validarEmailContacto = (email) => {
		if (this.cambioEmail && (email !== "" && this.validateEmailContacto(email))) {
			if (!this.correosValidadosContacto.hasOwnProperty(email)) {
				validacionEmail(email)
					.then(response => {
						const isValid = response.data;
						this.correosValidadosContacto[email] = isValid;
						if (isValid) {
							errorEmail = true;
						} else {
							this.countEmailsContacto();
						}
					})
			} else {
				if (!this.correosValidadosContacto[email]) {
					this.countEmailsContacto();
				}
			}
		}
		console.log("secondError", errorEmail);
	}

	countEmailsContacto = () => {
		this.contadorEmailContacto++;
		if (this.contadorEmailContacto === 1) {
			errorEmail = false;
			this.muestraTooltip(true, palabraError, MSJERRORCORREO, "El correo electrónico no es válido. Favor de verificar.");
		} else if (this.contadorEmailContacto === 2) {
			errorEmail = true;
			this.muestraTooltip(true, palabraError, MSJERRORCORREO, "El correo electrónico sigue identificado como inválido.");
		}else if(this.contadorEmailContacto > 3){
			console.log('listo');
			this.contadorEmailContacto = 0;
			errorEmail = false;
		}else {
			console.log('listo corro');
		}
	}

	validarCelularContacto = (valorCel) => {
		this.ladaCel = valorCel.substring(0, 3);

		const celComp = this.ladaCel + valorCel.substring(3, 10);

		if (this.cambioCel && (celComp !== "" && celComp.length === 10)) {

			if (!this.telefonosValidados.hasOwnProperty(celComp)) {
				validacionTel(celComp)
					.then(response => {
						const isValid = response.data.validacionMedioContacto;
						this.telefonosValidados[celComp] = isValid;

						if (isValid) {
							errorTelCelular = true;
							console.log("VALIDACIÓN EN LINEA CELULAR:", isValid, response.data);
						} else {
							this.countCelularContacto();
						}
					})
			} else {
				console.log("EL CELULAR YA ESTA VALIDADO", this.telefonosValidados);
				if (!this.telefonosValidados[celComp]) {
					this.countCelularContacto();
				}
			}
		} else {
			console.log("El teléfono celular no ha cambiado, no cumple con el formato o esta vacio, no se valida.");
		}
	}

	countCelularContacto = () => {
		this.countCelularContactoS++;
		if (this.countCelularContactoS === 1) {
			errorTelCelular = false;
			this.muestraTooltip(true, palabraError, ERRORMSJCEL, "El teléfono celular no es válido. Favor de verificar.");
		} else if (this.countCelularContactoS === 2) {
			errorTelCelular = true;
			this.muestraTooltip(true, palabraError, ERRORMSJCEL, "El teléfono celular sigue identificado como inválido.");
		}else if(this.countCelularContactoS > 3){
			console.log('listo');
			errorTelCelular = false;
			this.countCelularContactoS = 0;
		}else {
			console.log('termina')
		}
	}

	validarFijocc = (valorFijoCC) => {
		this.ladaFijo = valorFijoCC.substring(0, 3);
		const telCompContacto = this.ladaFijo + valorFijoCC.substring(3, 10);

		if (this.cambioFijoContacto && (telCompContacto !== "" && telCompContacto.length === 10)) {
			if (!this.telefonosValidados.hasOwnProperty(telCompContacto)) {
				validacionTel(telCompContacto)
					.then(response => {
						const isValid = response.data.validacionMedioContacto;
						this.telefonosValidados[telCompContacto] = isValid;
						if (isValid) {
							errorTelFijo = true;
						} else {
							this.countFijoContacto();
						}
					});
			} else {
				if (!this.telefonosValidados[telCompContacto]) {
					this.countFijoContacto();
				}
			}
		} else {
			console.log("El teléfono fijo no ha cambiado.");
		}
	}

	countFijoContacto = () => {
		console.log('count');
		this.contadorFijoC++;
		if (this.contadorFijoC === 1) {
			errorTelFijo = false;
			this.muestraTooltip(true, palabraError, ERRORCOUNTFIJO, "El teléfono fijo no es válido. Favor de verificar.");
		} else if (this.contadorFijoC === 2) {
			console.log('contador');
			errorTelFijo = true;
			this.muestraTooltip(true, palabraError, ERRORCOUNTFIJO, "El teléfono fijo sigue identificado como inválido.");
		}else if(this.contadorFijoC > 3){
			console.log('listo fijo');
			errorTelFijo= false;
			this.contadorFijoC = 0;
		}else {
			console.log('terminaf ij')
		}
	}

	handleBlur = (event) => {
		const id = event.target.name;
		const value = event.target.value;

		switch (id) {
			case "usuario":
				this.validarEmailContacto(value);
				break;
			case "celular":
				this.validarCelularContacto(value);
				break;
			case "telefono":
				this.validarFijocc(value);
				break;
		}
	}


	save = () => {		
		if (errorTelFijo && errorEmail && errorTelCelular) {
			if (this.state.viewBoton) {
				this.props.addEvento("Guardar-DatosPersonales");
			}
			this.setState({ checkFlag: true });
			const obj = this.objetoFormado(); 
			console.log("Datos a enviar", obj);

			obj.usuario = obj.usuario.toLowerCase();
			obj.usuarioC = obj.usuarioC.toLowerCase();
			let ok = true;

			for (var key in obj) {
				if (!obj[key]) {
					switch (key) {
						case "usuario":
							this.setState({ errorusuario: true });
							this.setState({ errorUsuarioMsj: campoRequerido });
							ok = false;
							break;
						case "celular":
							this.setState({ errorcelular: true });
							this.setState({ errorCelMsj: campoRequerido });
							ok = false;
							break;
					}
				}
			}
			this.save2(obj, ok);
		}else {
			console.log('valida');
		}
	}

	objetoFormado() {
		return {
			flag: "dp",
			usuario: this.refs.usr.value,
			usuarioC: this.refs.usr.value,
			lada: this.refs.cel.value!== "" ? this.refs.cel.value.substring(0, 2) : "",
			celular: this.refs.cel.value!== "" ? this.refs.cel.value.substring(2, 10) : "",
			ladaF:  this.refs.tel.value!== "" ? this.refs.tel.value.substring(0, 2) : "",
			telefono: this.refs.tel.value!== "" ? this.refs.tel.value.substring(2, 10) : "",
			ocupacion: this.refs.ocu.value,
			area: this.refs.aI.value
		}
	}

	save2 = (obj, ok) => {
		console.log("save 2");

		const ocupac = obj.ocupacion.trim();
		const celCompleto = obj.lada + obj.celular;
		const telCompleto = obj.ladaF + obj.telefono;

		if (obj.ocupacion && ocupac.length === 0) {
			console.log("1");
			this.setState({ errorocupacion: true });
			ok = false;
		}

		if (obj.usuario && !this.validateEmailContacto(obj.usuario)) {
			console.log("2");
			this.setState({ errorusuario: true });
			this.setState({ errorUsuarioMsj: "El formato no es válido. Favor de verificarlo." });
			ok = false;
		}

		if (celCompleto.length !== 10) {
			console.log("3");
			this.setState({ errorcelular: true });
			this.setState({ errorCelMsj: telefonoIncorrecto });
			ok = false;
		}

		if (obj.ladaF.length > 0 && obj.telefono.length > 0) {
			if (telCompleto.length !== 10) {
				console.log("4");
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: telefonoFijo });
				ok = false;
			}
		}
		if (telCompleto === celCompleto) {
			console.log("5");
			this.setState({ errortelefono: true });
			this.setState({ errorTelMsj: telefonoDiferente });
			ok = false;
		}

		if (ok) {
			console.log("6");

			this.setState({ errorocupacion: false });
			this.setState({ errorusuario: false });
			this.setState({ errorUsuarioMsj: "" });
			this.setState({ errorcelular: false });
			this.setState({ errorCelMsj: "" });
			this.setState({ errortelefono: false });
			this.setState({ errorTelMsj: "" });
			this.setState({ errortelefono: false });
			this.setState({ errorTelMsj: "" });
			this.save3(obj);
		}

	}

	save3 = (obj) => {
		console.log("Save 3");
		const usuarioActual =  document.getElementsByName("usuario")[0].value;

		const cc = obj.lada + obj.celular;
		const ct = obj.ladaF + obj.telefono;

		if (obj.usuario !== this.state.usuario || cc !== this.state.celular || ct !== this.state.telefono) {
			const tempObj = {
				usuario: obj.usuario,
				lada: obj.lada,
				celular: obj.celular,
				ladaF: obj.ladaF,
				telefono: obj.telefono
			};
			this.props.guardarMedios(tempObj);
			this.props.guardarAreaOcupacion(obj);
		} else {
			this.props.guardarAreaOcupacion(obj);
		}
		setTimeout(() => {
			this.muestraTooltip(false);
			this.cargarDatos();	
			if( this.state.usuario === usuarioActual) {
				goTo('mi-perfil');
				this.setState({ iconEdit: EditOrange });
				this.setState({ viewBoton: false });
			}else {
				cierraSesionAppLogin();
			}
		}, 2000);
	}

	handleChange = (event) => {
		console.log("Se llamo a handleChange");

		const id = event.target.name;
		const value = event.target.value;
		var i = 0;

		switch (id) {
			case 'usuario':
				event.target.value = event.target.value.replace(' ', '');
				this.cambioEmail = true;
				break;
			case "celular":
				this.handleChangeCelular(value, event);
				this.cambioCel = true;
				break;
			case "telefono":
				this.handleChangeCelular(value, event);
				this.cambioFijoContacto = true;
				break;
		}

		if (this.state.checkFlag) {
			this.handleChange2(event);
		}
	}

	handleChangeCelular = (value, event) => {
		if (value) {
			for (let i; i < value.length; i++) {
				if (isNaN(value[i]) || value[i] === " ") {
					event.target.value = value.replace(value[i], "");
					value = event.target.value;
				}
			}
		}
	}

	handleChange2 = (event) => {
		console.log("Se llamo a handleChange2");
		const id = event.target.name;
		const value = event.target.value;


		switch (id) {
			case "usuario":
				this.handleChange2Usuario(value);
				break;
			case "celular":
				this.handleChange2Celular(value);
				break;
			case "telefono":
				this.handleChange2Telefono(value);
				break;
		}
	}

	handleChange2Usuario = (value) => {

		if (!value) {
			this.setState({ errorusuario: true });
			this.setState({ errorUsuarioMsj: campoRequerido });
		} else {
			if (value) {
				this.setState({ errorusuario: false });
				this.setState({ errorUsuarioMsj: "" });
			}
		}
	}

	handleChange2Celular = (value) => {
		const completo = this.state.celular;
		var completoFijo = this.state.telefono;
		if (!value) {
			this.setState({ errorcelular: true });
			this.setState({ errorCelMsj: "Campo requerido." });
		} else {
			if (value && completo.length !== 10) {
				this.setState({ errorcelular: true });
				this.setState({ errorCelMsj: "Tu teléfono celular es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
			} else if (completo === completoFijo) {
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: telefonoDiferente });
			}
			else {
				this.setState({ errorcelular: false });
				this.setState({ errorCelMsj: "" });
				this.setState({ errortelefono: false });
				this.setState({ errorTelMsj: "" });
			}
		}
	}

	handleChange2Telefono = (value) => {
		const completo = this.refs.tel.value.substring(0, 2) + this.refs.tel.value.substring(2, 10);
		var completoCelular = this.refs.cel.value.substring(0, 2) + this.refs.cel.value.substring(2, 10);
		if (this.refs.tel.value.substring(0, 2).length > 0 && this.refs.tel.value.substring(2, 10).length === 0) {
			this.setState({ errortelefono: true });
			this.setState({ errorTelMsj: "Campo requerido." });
		} else
			if (completo.length !== 10) {
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: "Tu teléfono fijo es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
			}
			else
				if (completoCelular === completo) {
					this.setState({ errortelefono: true });
					this.setState({ errorTelMsj: telefonoDiferente });
				} else {
					this.setState({ errortelefono: false });
					this.setState({ errorTelMsj: "" });
				}
	}

	handleChangeArea = (event) => {
		console.log("event area", event.target.innerText);

		this.setState({ areaDeInteres: event.target.innerText });
		this.props.change({ areaDeInteres: event.target.innerText });
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	render() {

		return <div style={{ width: '95%', height: '400px', marginTop: "50px", marginLeft: "3%" }} className="Contacto">

			<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
				show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
			</ModalSintillo>

			<div id="div-titulo">
				<label className="titulo-contacto">Datos personales</label>
				<img alt="" src={this.state.iconEdit} onClick={this.edit.bind(this)} id="img-icon" />
				<hr id="hr" />
			</div>

			<div className="row">
				<div className="col-xs-8" id="email-contacto">
					<div className="input-wrap input-wrap-contacto input-otp">

						{!this.state.viewBoton && <div style={{ marginTop: "17px", marginLeft: "5px" }}>
							<label style={{ color: "#567099" }}>Usuario</label><br />
							<label style={{ color: "black" }}>{this.state.usuario}</label>
						</div>}

						{this.state.viewBoton && <Field
							name="usuario" max="30" component={campo} type="text" label="Usuario" maxLength="50"
							ref="usr" id="usuario" defaultValue={this.state.usuario} onBlur={this.handleBlur}
							onKeyPress={this.save} onChange={this.handleChange}
						/>}
						{this.state.errorusuario &&
							<div className="error-wrap">
								<div className="msj-error">
									<p>{this.state.errorUsuarioMsj}</p>
								</div>
							</div>
						}
					</div>
				</div>
			</div>

			{!this.state.viewBoton && <div className="datos-wrap mt-10" >
				<div className="row">
					<div className="col-xs-8" id="celular-contacto" style={{ marginLeft: "-11px" }}>
						<div className="input-wrap input-wrap-contacto input-otp">
							<div style={{ marginTop: "10px" }}>
								<label style={{ color: "#567099" }}>Teléfono celular</label><br />
								<label style={{ color: "black" }}>{this.state.celular}</label>
							</div>
						</div>
					</div>

					<div className="col-xs-8" id="fijo-contacto">
						<div className="input-wrap input-wrap-contacto input-otp">
							<div style={{ marginTop: "10px" }}>
								<label style={{ color: "#567099" }}>Teléfono fijo</label><br />
								<label style={{ color: "black" }}>{this.state.telefono}</label>
							</div>
						</div>
					</div>
				</div>
			</div>}

			{this.state.viewBoton && <div className="datos-wrap mt-10" >
				<div className="row">
					<div className="col-xs-8" id="celular-contacto" style={{ marginLeft: "-11px" }}>
						<div className="input-wrap input-wrap-contacto input-otp">
							<Field
								name="celular" max="10" ref="cel" id="celular" component={campo} onBlur={this.handleBlur}
								type="text" label="Teléfono celular" defaultValue={this.state.celular}
								onKeyPress={this.save} onChange={this.handleChange}
							/>
							{this.state.errorcelular &&
								<div className="error-wrap">
									<div className="msj-error">
										<p>{this.state.errorCelMsj}</p>
									</div>
								</div>
							}
						</div>
					</div>

					<div className="col-xs-8" id="fijo-contacto">
						<div className="input-wrap input-wrap-contacto input-otp">
							<Field
								name="telefono" max="10" ref="tel" id="telefono" component={campo} onBlur={this.handleBlur}
								type="text" label="Teléfono fijo" defaultValue={this.state.telefono}
								onKeyPress={this.save} onChange={this.handleChange}
							/>
							{this.state.errortelefono &&
								<div className="error-wrap">
									<div className="msj-error">
										<p>{this.state.errorTelMsj}</p>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>}

			{!this.state.viewBoton && <div className="datos-wrap mt-10">
				<div className="row">
					<div className="col-xs-8" id="ocupacion-contacto" style={{ marginLeft: "-11px" }}>
						<div className="input-wrap input-wrap-contacto input-otp">
							<div style={{ marginTop: "10px" }}>
								<label style={{ color: "#567099" }}>Ocupación</label><br />
								<label style={{ color: "black" }}>{this.state.ocupacion}</label>
							</div>
						</div>
					</div>

					<div className="col-xs-8" id="area-interes">
						<div className="input-wrap input-wrap-contacto input-otp">
							<div style={{ marginTop: "10px" }}>
								<label style={{ color: "#567099" }}>Área de interés</label><br />
								<label style={{ color: "black" }}>{this.state.areaDeInteres}</label>
							</div>
						</div>
					</div>
				</div>
			</div>}

			{this.state.viewBoton && <div className="datos-wrap mt-10">
				<div className="row">
					<div className="col-xs-8" id="ocupacion-contacto" style={{ marginLeft: "-11px" }}>
						<div className="input-wrap input-wrap-contacto input-otp">
							<Field
								name="ocupacion" type="text" ref="ocu" id="ocupacion" component={campo} onBlur={this.handleBlur}
								max="50" label="Ocupación" defaultValue={this.props.ocupacion}
								onKeyPress={this.save} onChange={this.handleChange}
							/>
							{this.state.errorocupacion &&
								<div className="error-wrap">
									<div className="msj-error">
										<p>No se pueden guardar solo espacios.</p>
									</div>
								</div>
							}
						</div>
					</div>

					<div className="col-xs-8" id="area-interes">
						<div className="input-wrap input-wrap-contacto input-otp">
							<Field name="areaDeInteres" type="text" ref="aI" id="areaDeInteres" component={campoSelect} style={{ color: "black" }}
								label="Área de interés" value={this.state.areaDeInteresId} defaultValue={this.state.areaDeInteresId} change={this.handleChangeArea.bind(this)}>
								<option value=""></option>
								{areas.map((item, id) => {
									return <MenuItem key={id} value={item.id} primaryText={item.area} />
								})}
							</Field>
							{this.state.errorarea &&
								<div className="error-wrap">
									<div className="msj-error">
										<p>Obligatorio</p>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>}

			{this.state.viewBoton && <div className="row btn-bottom">
				<div className="col-xs-12" style={{ marginTop: "-15px" }}>
					<button type="submit" id="btn-guardar-contacto" className="orange-rectangle btn" onClick={this.save.bind(this)}>
						Guardar
					</button>
					<button type="button" id="btn-cancelar-contacto" className="btn-cancelar" onClick={this.cancelar.bind(this)}>Cancelar</button>
				</div>
			</div>}

		</div>
	}
}

ContactoForm = reduxForm({ form: "datos-contacto" })(ContactoForm);
export default connect(mapState, mapDispatch)(ContactoForm);



// WEBPACK FOOTER //
// ./src/gnp-datos-contacto/contacto.frm.js